export const isMemberOfBoard = <
  TInputBoard extends {
    memberships?: { idMember: string }[] | null;
  },
>(
  board: TInputBoard,
  idMember: string,
): boolean => {
  // There are cases where `memberships` are returning null
  // and are not caught by typescript
  // TODO investigate how board.memberships can be null and why
  // typescript is not catching these errors
  if (!board.memberships) {
    return false;
  }

  return board.memberships.some(
    (membership) => membership.idMember === idMember,
  );
};
